export const mbMyAccount = {
  mbMyAccount: {
    welcome: 'Nice to see you,\n',
    welcomeMobile: 'Nice to see you, ',
    universityLinkText: 'Explore your opportunities to grow',
    pspLinkText: 'Configure your personal antibodies',
    mpupLinkText: 'Overview of your MACS Pick Up Point',
    logout: 'Logout',
    backToMyAccount: 'Back to my account',
    backToOrderHistory: 'Back to order history',
    ordersAndRequests: 'Orders and requests',
    contact: {
      help: 'Need help?',
      support: 'We’re here for you',
      hotline: 'Hotline',
      emailSupport: 'Email support',
      emailSupportMail: 'Contact customer service team',
    },
    navigation: {
      home: 'Home',
      addressBook: 'Address Book',
      newsletter: 'Newsletter',
      profileSettings: 'Profile',
      orderHistory: 'Order History',
      wishlist: 'Favorites'
    },
    mbMyAddressbook: {
      headerAddresses: 'My addresses',
      headerBillingAddresses: 'Billing addresses',
      headerShippingAddresses: 'Shipping addresses',
      header: 'Address book',
      emptyAddress: {
        headline: 'Empty',
        messageShipping: 'You can add a shipping address during order process.',
        messageBilling: 'You can add a billing address during order process.',
        linkText: 'Browse products'
      }
    },
    wishlist: {
      totalItems: 'product(s) on your favorites list',
      title: 'Favorites list',
      remove: 'Remove from favorites',
      empty: {
        message: 'Your favorites list is currently empty. Please add some great products.',
        linkText: 'Browse products'
      }
    },
    orderHistory: {
      orderType: 'Type',
      mixedOrder: 'Purchase, Request',
      noOrders: {
        message: 'You have not placed an order with this account in the past.',
        linkText: 'Browse products'
      }
    }
  }
}
